import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is fresh for 30 seconds
      staleTime: 30 * 1000,
      // Cache data for 5 minutes
      gcTime: 5 * 60 * 1000,
      // Retry failed requests once
      retry: 1,
      // Refetch on window focus (but respects staleTime)
      refetchOnWindowFocus: true,
    },
  },
});

// Query keys for cache management
export const queryKeys = {
  diagrams: {
    all: ['diagrams'] as const,
    list: (folderId?: string | null) => ['diagrams', 'list', folderId] as const,
    detail: (id: string) => ['diagrams', 'detail', id] as const,
  },
  folders: {
    all: ['folders'] as const,
    list: () => ['folders', 'list'] as const,
    detail: (id: string) => ['folders', 'detail', id] as const,
  },
  subscription: {
    info: () => ['subscription', 'info'] as const,
  },
} as const;
